export function removeUndefined<T>(x: T|undefined){
    return x != undefined;
}